/**
 * お知らせカウントの非同期取得
 * @param {*} selector 
 */
 window.sidebar_information_load = function(selector, callback = null) {
    if($(selector).length == 0){
        return;
    }
    let datas = [];
    let action = $(selector).data('action');
    let type = $(selector).data('type');
    datas.push({
        'name': 'type', 
        'value': type 
    });
    _ajax.background(action, datas, function (res) {
        let results = JSON.parse(res);
        let total = results.count;
        let badge = create_id($(selector).data('badge_id'));
        if (total > 0) {
            if(total > 50){
                total = '50+';
            }
            $(badge).text(total);
            $(badge).toggleClass('display-none', false);
            $(badge).toggleClass('badge-danger', true);
        }else{
            $(badge).empty();
            $(badge).toggleClass('display-none', true);
            $(badge).toggleClass('badge-danger', false);
        }
        if (callback != null) {
            callback();
        }
    }, function(xhr, status, errorThrown) {
        _error.omitted(xhr, status, errorThrown);
    }, 'html');
}